import(/* webpackMode: "eager" */ "/codebuild/output/src135302362/src/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/codebuild/output/src135302362/src/src/app/providers.tsx");
